import { Route } from '@angular/router';

import { AdviserOptionsScreenComponent } from './components/screens/adviser-options-screen/adviser-options-screen.component';
import { CoverageScreenComponent } from './components/screens/coverage-screen/coverage-screen.component';
import { DashboardScreenComponent } from './components/screens/dashboard-screen/dashboard-screen.component';
import { GenericErrorScreenComponent } from './components/screens/generic-error-screen/generic-error-screen.component';
import { OAuthCallbackScreenComponent } from './components/screens/oauth-callback-screen/oauth-callback-screen.component';
import { ReviewCompleteScreenComponent } from './components/screens/review-complete-screen/review-complete-screen.component';
import { AuthGuard } from './shared/services/auth.guard';

export const appRoutes: Route[] = [
  { path: '', component: GenericErrorScreenComponent },
  { path: 'callback', component: OAuthCallbackScreenComponent }, // Handles Return from Salesforce OAuth flow
  { path: 'dashboard', component: DashboardScreenComponent, canActivate: [AuthGuard] },
  { path: 'coverage', component: CoverageScreenComponent, canActivate: [AuthGuard] },
  { path: 'adviser-options', component: AdviserOptionsScreenComponent, canActivate: [AuthGuard] },
  { path: 'review-complete', component: ReviewCompleteScreenComponent, canActivate: [AuthGuard] },
  { path: 'access-denied', component: GenericErrorScreenComponent },
  { path: 'unknown-error', component: GenericErrorScreenComponent },
  { path: '**', component: GenericErrorScreenComponent }, // Wildcard route for handling 404 errors
];
